import React, { useState } from "react";
import LogoAndCompName from "./UI/LogoAndCompName";
import HeaderSocialLinks from "./HeaderSocialLinks";
import { headerSocialLinksArray, footerSocialLinks } from "../data/HeaderSocialLinksData";
import { LegalAdvisePageHtml } from "./FooterPages";
import { TermsOfusePageHtml } from "./FooterPages";
import { CookiePolicyPageHtml } from "./FooterPages";
import { ContactsPageHtml } from "./FooterPages";
//import Banner from "./UI/AdBanner";
import FooterSocialLinks from "./FooterSocialLinks";

const Footer = () => {
    const [pageContent, setPageContent] = useState('');

    const openFooterPage = (e, content) => {
        if(document.querySelector('.blue-link')) {
            document.querySelector('.blue-link').classList.remove('blue-link');
        }
        e.target.classList.add('blue-link');
        setPageContent(content);
        if(document.querySelector('.footer-outer')) {
            document.querySelector('.footer-outer').scrollIntoView()
        }
    }

    const closeFooterPage = () => {
        if(document.querySelector('.blue-link')) {
            document.querySelector('.blue-link').classList.remove('blue-link');
        }
        setPageContent('');
    }

    const FooterBanner = () => {
        return (
            <a href="https://raidsharksbot.com/" target="_blank" rel="noreferrer">
                <img alt="footer_banner" src="/img/raidsharks-50-rev.gif" loading="lazy" /> 
            </a>
        )
    }

    return (
        <div className="footer-bg">
            <div className="footer-outer">
                <div className="app-footer">
                    {pageContent !== '' ? (
                        <div className="f-p-content">
                            <div className="f-p-inner">
                                <span className="close-f-p" onClick={closeFooterPage}></span>
                                {pageContent !== '' && pageContent === 'Legal' ? (<LegalAdvisePageHtml />) : null}
                                {pageContent !== '' && pageContent === 'Terms' ? (<TermsOfusePageHtml />) : null}
                                {pageContent !== '' && pageContent === 'Cookie' ? (<CookiePolicyPageHtml />) : null}
                                {pageContent !== '' && pageContent === 'Contact' ? (<ContactsPageHtml />) : null}
                            </div>
                        </div>
                    ) : null}
                    <div>
                        <div className="h-20"></div>
                        <ul className="footerLinks flex-box"> 
                            <li className="footer-link inter-bold-16" onClick={(e) => openFooterPage(e, 'Terms')}>Terms of use</li>                                  
                            <li className="footer-link inter-bold-16" onClick={(e) => openFooterPage(e, 'Cookie')}>Cookies</li>
                            <li className="footer-link inter-bold-16" onClick={(e) => openFooterPage(e, 'Legal')}>Legal Advice</li>
                            <li><img src="img/sgt-coinmarket-logo.png" alt="coinmarketcap" /> <a className="footer-link inter-bold-16" href="https://coinmarketcap.com/currencies/shill-guard-token/" target="_blank" rel="noreferrer">Coinmarketcap</a></li>
                            <li><img src="img/sgt-coingecko-logo.png" alt="coingecko" style={{"marginRight": "5px"}}/><a className="footer-link inter-bold-16" href="https://www.coingecko.com/en/coins/shill-guard-token" target="_blank" rel="noreferrer">Coingecko</a></li>
                        </ul>
                        <div className="h-20"></div>
                        <div className="footer-social-links">
                            <FooterSocialLinks links={footerSocialLinks} />
                        </div>
                    </div>
                    <p className="copy-right inter-bold-16">
                        Copyright© 2025 ShillGuard. All rights reserved.
                    </p>
                </div>
            </div>
            {/* <div>
                <Banner />
            </div> */}
        </div>
    )
}

export default Footer;